import React, { FC } from 'react'
import {
  DeprecatedControlledSelect,
  IDeprecatedControlledSelectProps,
} from 'transfix-form/components/ControlledSelect/ControlledSelect'
import { unitTypeOptions } from 'apps/fleet-planner/constants'

interface IControlledSelectUnitTypeProps extends IDeprecatedControlledSelectProps {}

/**
 * Helper component for use with React Hook Form
 * @see https://react-hook-form.com/api#Controller
 * @example
 * ```
 * <ControlledSelectUnitType name='unitType' control={control} />
 * ```
 */
export const ControlledSelectUnitType: FC<IControlledSelectUnitTypeProps> = ({
  control,
  defaultValue,
  name,
  SelectProps = {},
}) => {
  const { label = 'Unit type', options = unitTypeOptions, ...rest } = SelectProps || {}
  return (
    <DeprecatedControlledSelect
      control={control}
      defaultValue={defaultValue}
      name={name}
      SelectProps={{
        label,
        options,
        ...rest,
      }}
    />
  )
}
